//  ----------      START   IMPORT  BLOCK       ----------
//  Services
import APIService from '../Core/APIService';
//  Config
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
//  ----------      END   IMPORT  BLOCK       ----------

export default class OdontogramService extends APIService {
  /**
   * Creates a new odontogram entry.
   */
  async createEntry(patient_username, teeth_notes, general_note) {
    const dataToSend = { 
      patient_username: patient_username,
      teeth_notes: teeth_notes, 
      general_note: general_note, 
    };

    const route = API_ROUTES.create_odontogram_entry;
    return this.post(route, dataToSend);
  }

  /**
   * Fetches the historical odontogram entries for a patient.
   * @param {string} query - The patient's username.
   */
  async fetchHistory(query) {
    const route = API_ROUTES.fetch_odontogram_history(query);
    return this.get(route);
  }
}